import { render, staticRenderFns } from "./edit-blueprint.vue?vue&type=template&id=4f90d2b5&scoped=true&"
import script from "./edit-blueprint.vue?vue&type=script&lang=ts&"
export * from "./edit-blueprint.vue?vue&type=script&lang=ts&"
import style0 from "./edit-blueprint.vue?vue&type=style&index=0&id=4f90d2b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90d2b5",
  null
  
)

export default component.exports